import React, { useCallback } from 'react';
import { FileTab } from '@/types';
import { FileIcon } from '../Decorations/FileIcon';
import { StatusIndicator } from '../Decorations/FileIcon';
import '../../styles/tabs-mobile.css';

interface TabMobileProps {
  tab: FileTab;
  isActive: boolean;
  isDragging?: boolean;
  onTap: () => void;
  onLongPress: () => void;
  onDragStart: () => void;
  onDragEnd: () => void;
}

export const Tab: React.FC<TabMobileProps> = React.memo(({
  tab,
  isActive,
  isDragging,
  onTap,
  onLongPress,
  onDragStart,
  onDragEnd,
}) => {
  const truncateFilename = (name: string, maxLength: number = 12): string => {
    if (name.length <= maxLength) return name;

    const lastDotIndex = name.lastIndexOf('.');
    if (lastDotIndex === -1) {
      return name.substring(0, maxLength - 1) + '…';
    }

    const ext = name.substring(lastDotIndex);
    const nameWithoutExt = name.substring(0, lastDotIndex);
    const availableLength = maxLength - ext.length - 1;

    return nameWithoutExt.substring(0, availableLength) + '…' + ext;
  };

  return (
    <div
      className={`tab-mobile ${isActive ? 'active' : ''} ${isDragging ? 'dragging' : ''}`}
      data-tab-id={tab.id}
      onClick={onTap}
      onLongPress={onLongPress}
      onTouchStart={onDragStart}
      onTouchEnd={onDragEnd}
    >
      <FileIcon language={tab.language} size={14} />
      <span className={`tab-label-mobile ${tab.isPreview ? 'preview' : ''}`}>
        {truncateFilename(tab.name)}
      </span>
      <StatusIndicator
        isDirty={tab.isDirty}
        isModified={tab.isModified}
        isPinned={tab.isPinned}
      />
    </div>
  );
});

Tab.displayName = 'TabMobile';